import React from 'react'
import { Icon } from 'components/atoms'
import { BufferingIcon } from 'assets/icons'
import { theme } from 'utils/theme'
import * as S from './styled'

const Loader = () => (
  <S.Loading>
    <Icon Source={BufferingIcon} width='100px' height='100px' color={theme.colors.lightGold} />
  </S.Loading>
)

export default Loader
